import { useFormContext } from 'react-hook-form';
import { FormControlLabel, TextField } from '@mui/material';
import { useHasLockedStatus } from '~/hooks/dataset';
import { MAX_DESCRIPTION_LENGTH } from '~/validation/datasetSchema';

const DescriptionField = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { hasLockedStatus } = useHasLockedStatus();

  return (
    <FormControlLabel
      label="DESCRIPTION"
      required
      control={
        <TextField
          {...register('description')}
          multiline
          minRows={2}
          maxRows={6}
          error={!!errors.description}
          helperText={(errors.description?.message as string) || `Max ${MAX_DESCRIPTION_LENGTH} characters`}
          disabled={hasLockedStatus}
          slotProps={{ htmlInput: { maxLength: MAX_DESCRIPTION_LENGTH } }}
        />
      }
    />
  );
};

export default DescriptionField;
